var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { maxWidth: "1100px", bus: _vm.busModal, persistent: "" },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("Title", {
                attrs: {
                  title: "Registro de Carteira Administrada",
                  underlined: ""
                }
              })
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading },
                  on: { click: _vm.save }
                },
                [_vm._v(" Salvar ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "carteira-administrada" },
        [
          _vm.shouldShowCreateNotice
            ? _c(
                "BaseAlert",
                {
                  staticClass: "carteira-administrada__notice",
                  attrs: {
                    "icon-color": "warning",
                    icon: "warning",
                    status: "warning"
                  }
                },
                [
                  _c("span", { staticClass: "text-normal" }, [
                    _vm._v(
                      " Nenhum registro encontrado para o cliente selecionado. Preencha os dados abaixo para cadastrar. "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _c(
            "v-form",
            { ref: "form" },
            [
              _c(
                "v-row",
                { staticClass: "mt-4", attrs: { justify: "space-between" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "label",
                        { staticClass: "carteira-administrada__label" },
                        [_vm._v(" " + _vm._s(_vm.label.selectedClient) + " ")]
                      ),
                      _c("v-autocomplete", {
                        staticClass: "new-ux",
                        attrs: {
                          placeholder: "Selecionar",
                          outlined: "",
                          disabled: _vm.loading,
                          items: _vm.clients,
                          "item-value": "id",
                          "item-text": "name",
                          rules: [_vm.rules.required]
                        },
                        model: {
                          value: _vm.form.selectedClient,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "selectedClient", $$v)
                          },
                          expression: "form.selectedClient"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "mt-6", attrs: { cols: "auto" } },
                    [
                      _vm.isEditMode
                        ? _c(
                            "BaseButton",
                            {
                              attrs: {
                                secondary: "",
                                text: "",
                                small: "",
                                loading: _vm.loading,
                                disabled:
                                  !_vm.form.selectedClient || _vm.loading
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.confirmRemove($event)
                                }
                              }
                            },
                            [
                              _c("icon-svg", {
                                attrs: { color: "red", name: "remove" }
                              }),
                              _vm._v(" Excluir carteira ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.form.selectedClient && !_vm.loading
                ? _c(
                    "div",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "carteira-administrada__subtitle"
                              },
                              [_vm._v("Dados Gerais")]
                            )
                          ]),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [_vm._v(" Código Anbima ")]
                              ),
                              _c("v-text-field", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "number",
                                  outlined: "",
                                  hint: _vm.codigoMessages
                                },
                                model: {
                                  value: _vm.form.codigo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "codigo", $$v)
                                  },
                                  expression: "form.codigo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.statusCarteira) + " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.statusCarteira,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.statusCarteira,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "statusCarteira", $$v)
                                  },
                                  expression: "form.statusCarteira"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.primeiroAporte) + " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "date",
                                  placeholder: "DD/MM/AAAA",
                                  outlined: "",
                                  rules: [_vm.rules.required, _vm.rules.data]
                                },
                                model: {
                                  value: _vm.form.primeiroAporte,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "primeiroAporte", $$v)
                                  },
                                  expression: "form.primeiroAporte"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.encerramentoContrato
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.encerramentoContrato) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "date",
                                  placeholder: "DD/MM/AAAA",
                                  outlined: "",
                                  disabled:
                                    _vm.fieldDisabled.encerramentoContrato,
                                  rules:
                                    _vm.conditionalRules.encerramentoContrato
                                },
                                model: {
                                  value: _vm.form.encerramentoContrato,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "encerramentoContrato",
                                      $$v
                                    )
                                  },
                                  expression: "form.encerramentoContrato"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.modeloCarteira) + " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.modeloCarteira,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.modeloCarteira,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "modeloCarteira", $$v)
                                  },
                                  expression: "form.modeloCarteira"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.segmentoInvestidor) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.segmentoInvestidor,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.segmentoInvestidor,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "segmentoInvestidor",
                                      $$v
                                    )
                                  },
                                  expression: "form.segmentoInvestidor"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.publicoAlvo) + " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.publicoAlvo,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.publicoAlvo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "publicoAlvo", $$v)
                                  },
                                  expression: "form.publicoAlvo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.publicoAlvo
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.riscoCarteira) + " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "text",
                                  outlined: "",
                                  disabled: _vm.fieldDisabled.publicoAlvo,
                                  rules: _vm.conditionalRules.riscoCarteira
                                },
                                model: {
                                  value: _vm.form.riscoCarteira,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "riscoCarteira", $$v)
                                  },
                                  expression: "form.riscoCarteira"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.publicoAlvo
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.riscoInvestidor) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "text",
                                  outlined: "",
                                  disabled: _vm.fieldDisabled.publicoAlvo,
                                  rules: _vm.conditionalRules.riscoInvestidor
                                },
                                model: {
                                  value: _vm.form.riscoInvestidor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "riscoInvestidor", $$v)
                                  },
                                  expression: "form.riscoInvestidor"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "carteira-administrada__subtitle"
                              },
                              [_vm._v("Permissões")]
                            )
                          ]),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.creditoPrivado) + " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.simNao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.creditoPrivado,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "creditoPrivado", $$v)
                                  },
                                  expression: "form.creditoPrivado"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.investimentoExterior) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.simNao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.investimentoExterior,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "investimentoExterior",
                                      $$v
                                    )
                                  },
                                  expression: "form.investimentoExterior"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.label.investimentoCotasFundos
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.simNao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.investimentoCotasFundos,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "investimentoCotasFundos",
                                      $$v
                                    )
                                  },
                                  expression: "form.investimentoCotasFundos"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.derivativos) + " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.simNao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.derivativos,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "derivativos", $$v)
                                  },
                                  expression: "form.derivativos"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.estrategiasDerivativos
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.estrategiasDerivativos) +
                                      " "
                                  )
                                ]
                              ),
                              _c("AutocompleteMany", {
                                staticClass:
                                  "carteira-administrada__select-multiple",
                                attrs: {
                                  items: _vm.mappedEstrategiasDerivativos,
                                  selected: _vm.form.estrategiasDerivativos,
                                  multiple: true,
                                  "selected-items-to-show": 2,
                                  "loading-props": _vm.loading,
                                  "disabled-props":
                                    _vm.fieldDisabled.estrategiasDerivativos,
                                  rules:
                                    _vm.conditionalRules.estrategiasDerivativos,
                                  "show-details": true
                                },
                                on: {
                                  "update:selected": function($event) {
                                    return _vm.$set(
                                      _vm.form,
                                      "estrategiasDerivativos",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "carteira-administrada__subtitle"
                              },
                              [_vm._v("Taxas")]
                            )
                          ]),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.tipoTaxaGestao) + " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.tipoTaxaGestao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.tipoTaxaGestao,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "tipoTaxaGestao", $$v)
                                  },
                                  expression: "form.tipoTaxaGestao"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.valorTaxaGestao
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.valorTaxaGestao) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type:
                                    _vm.form.tipoTaxaGestao === "Percentual"
                                      ? "percent"
                                      : "money",
                                  outlined: "",
                                  disabled: _vm.fieldDisabled.valorTaxaGestao,
                                  rules: _vm.conditionalRules.valorTaxaGestao
                                },
                                model: {
                                  value: _vm.form.valorTaxaGestao,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "valorTaxaGestao", $$v)
                                  },
                                  expression: "form.valorTaxaGestao"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.descricaoTaxaGestao) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "text",
                                  outlined: "",
                                  rules:
                                    _vm.conditionalRules.descricaoTaxaGestao
                                },
                                model: {
                                  value: _vm.form.descricaoTaxaGestao,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "descricaoTaxaGestao",
                                      $$v
                                    )
                                  },
                                  expression: "form.descricaoTaxaGestao"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.label.cobrancaTaxaComplementar
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.simNao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.cobrancaTaxaComplementar,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "cobrancaTaxaComplementar",
                                      $$v
                                    )
                                  },
                                  expression: "form.cobrancaTaxaComplementar"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.cobrancaTaxaComplementar
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.label.tipoCobrancaTaxaComplementar
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.tipoCobrancaTaxa,
                                  disabled:
                                    _vm.fieldDisabled.cobrancaTaxaComplementar,
                                  rules:
                                    _vm.conditionalRules
                                      .tipoCobrancaTaxaComplementar
                                },
                                model: {
                                  value: _vm.form.tipoCobrancaTaxaComplementar,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "tipoCobrancaTaxaComplementar",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.tipoCobrancaTaxaComplementar"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.valorTaxaComplementar
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.valorTaxaComplementar) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type:
                                    _vm.form.tipoCobrancaTaxaComplementar ===
                                    "Percentual"
                                      ? "percent"
                                      : "money",
                                  outlined: "",
                                  disabled:
                                    _vm.fieldDisabled.valorTaxaComplementar,
                                  rules:
                                    _vm.conditionalRules.valorTaxaComplementar
                                },
                                model: {
                                  value: _vm.form.valorTaxaComplementar,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "valorTaxaComplementar",
                                      $$v
                                    )
                                  },
                                  expression: "form.valorTaxaComplementar"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.label.descricaoTaxaComplementar
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "text",
                                  outlined: "",
                                  rules:
                                    _vm.conditionalRules
                                      .descricaoTaxaComplementar
                                },
                                model: {
                                  value: _vm.form.descricaoTaxaComplementar,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "descricaoTaxaComplementar",
                                      $$v
                                    )
                                  },
                                  expression: "form.descricaoTaxaComplementar"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.label.cobrancaTaxaPerformance
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.simNao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.cobrancaTaxaPerformance,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "cobrancaTaxaPerformance",
                                      $$v
                                    )
                                  },
                                  expression: "form.cobrancaTaxaPerformance"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.cobrancaTaxaPerformance
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.label.tipoCobrancaTaxaPerformance
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.tipoCobrancaTaxa,
                                  disabled:
                                    _vm.fieldDisabled.cobrancaTaxaPerformance,
                                  rules:
                                    _vm.conditionalRules
                                      .tipoCobrancaTaxaPerformance
                                },
                                model: {
                                  value: _vm.form.tipoCobrancaTaxaPerformance,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "tipoCobrancaTaxaPerformance",
                                      $$v
                                    )
                                  },
                                  expression: "form.tipoCobrancaTaxaPerformance"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.valorTaxaPerformance
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.valorTaxaPerformance) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type:
                                    _vm.form.tipoCobrancaTaxaPerformance ===
                                    "Percentual"
                                      ? "percent"
                                      : "money",
                                  outlined: "",
                                  disabled:
                                    _vm.fieldDisabled.valorTaxaPerformance,
                                  rules:
                                    _vm.conditionalRules.valorTaxaPerformance
                                },
                                model: {
                                  value: _vm.form.valorTaxaPerformance,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "valorTaxaPerformance",
                                      $$v
                                    )
                                  },
                                  expression: "form.valorTaxaPerformance"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.label.descricaoTaxaPerformance
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "text",
                                  outlined: "",
                                  rules:
                                    _vm.conditionalRules
                                      .descricaoTaxaPerformance
                                },
                                model: {
                                  value: _vm.form.descricaoTaxaPerformance,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "descricaoTaxaPerformance",
                                      $$v
                                    )
                                  },
                                  expression: "form.descricaoTaxaPerformance"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", {
                        staticStyle: {
                          "border-top": "1px solid #8e8e8e80",
                          "margin-block": "16px"
                        }
                      }),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.utilizaBenchmark) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.simNao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.utilizaBenchmark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "utilizaBenchmark", $$v)
                                  },
                                  expression: "form.utilizaBenchmark"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled": _vm.fieldDisabled.benchmark
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.benchmark) + " "
                                  )
                                ]
                              ),
                              _c("AutocompleteMany", {
                                staticClass:
                                  "carteira-administrada__select-multiple",
                                attrs: {
                                  items: _vm.mappedBenchmarks,
                                  selected: _vm.form.benchmark,
                                  multiple: true,
                                  "selected-items-to-show": 2,
                                  "loading-props": _vm.loading,
                                  "disabled-props": _vm.fieldDisabled.benchmark,
                                  rules: _vm.conditionalRules.benchmark,
                                  "show-details": true
                                },
                                on: {
                                  "update:selected": function($event) {
                                    return _vm.$set(
                                      _vm.form,
                                      "benchmark",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "4" } }),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.custodianteContratado) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.simNao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.custodianteContratado,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "custodianteContratado",
                                      $$v
                                    )
                                  },
                                  expression: "form.custodianteContratado"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled
                                        .cnpjCustodianteContratado
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.label.cnpjCustodianteContratado
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "cnpj",
                                  outlined: "",
                                  disabled:
                                    _vm.fieldDisabled.cnpjCustodianteContratado,
                                  rules:
                                    _vm.conditionalRules
                                      .cnpjCustodianteContratado
                                },
                                model: {
                                  value: _vm.form.cnpjCustodianteContratado,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "cnpjCustodianteContratado",
                                      $$v
                                    )
                                  },
                                  expression: "form.cnpjCustodianteContratado"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "4" } }),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.controladorContratado) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.simNao,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.controladorContratado,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "controladorContratado",
                                      $$v
                                    )
                                  },
                                  expression: "form.controladorContratado"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.cnpjControlador
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.cnpjControlador) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "cnpj",
                                  outlined: "",
                                  disabled: _vm.fieldDisabled.cnpjControlador,
                                  rules: _vm.conditionalRules.cnpjControlador
                                },
                                model: {
                                  value: _vm.form.cnpjControlador,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cnpjControlador", $$v)
                                  },
                                  expression: "form.cnpjControlador"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "4" } }),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.aprecamentoCarteira) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.aprecamentoCarteira,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.aprecamentoCarteira,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "aprecamentoCarteira",
                                      $$v
                                    )
                                  },
                                  expression: "form.aprecamentoCarteira"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.label.cnpjResponsavelAprecamento
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "cnpj",
                                  outlined: "",
                                  rules: [_vm.rules.required, _vm.rules.cnpj]
                                },
                                model: {
                                  value: _vm.form.cnpjResponsavelAprecamento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "cnpjResponsavelAprecamento",
                                      $$v
                                    )
                                  },
                                  expression: "form.cnpjResponsavelAprecamento"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "carteira-administrada__label",
                                  class: {
                                    "text-disabled":
                                      _vm.fieldDisabled.publicoAlvo
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.rentabilidadeTir) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "percent",
                                  placeholder: "0,00",
                                  outlined: "",
                                  "decimal-length": { min: 2, max: 7 },
                                  disabled: _vm.fieldDisabled.publicoAlvo,
                                  rules: _vm.conditionalRules.rentabilidadeTir
                                },
                                model: {
                                  value: _vm.form.rentabilidadeTir,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "rentabilidadeTir", $$v)
                                  },
                                  expression: "form.rentabilidadeTir"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [_vm._v(" " + _vm._s(_vm.label.aportes) + " ")]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "money",
                                  placeholder: "0,00",
                                  outlined: "",
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.aportes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "aportes", $$v)
                                  },
                                  expression: "form.aportes"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [_vm._v(" " + _vm._s(_vm.label.resgates) + " ")]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "money",
                                  placeholder: "0,00",
                                  outlined: "",
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.resgates,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "resgates", $$v)
                                  },
                                  expression: "form.resgates"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.volumeFinanceiro) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "money",
                                  placeholder: "0,00",
                                  outlined: "",
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.volumeFinanceiro,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "volumeFinanceiro", $$v)
                                  },
                                  expression: "form.volumeFinanceiro"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.label.valorAplicadoCotas) +
                                      " "
                                  )
                                ]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: {
                                  type: "money",
                                  placeholder: "0,00",
                                  outlined: "",
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.valorAplicadoCotas,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "valorAplicadoCotas",
                                      $$v
                                    )
                                  },
                                  expression: "form.valorAplicadoCotas"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.label.criptoativos) + " "
                                  )
                                ]
                              ),
                              _c("v-autocomplete", {
                                staticClass: "new-ux",
                                attrs: {
                                  placeholder: "Selecionar",
                                  outlined: "",
                                  items: _vm.options.criptoativos,
                                  rules: [_vm.rules.required]
                                },
                                model: {
                                  value: _vm.form.criptoativos,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "criptoativos", $$v)
                                  },
                                  expression: "form.criptoativos"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "label",
                                { staticClass: "carteira-administrada__label" },
                                [_vm._v(" Campo de apoio ")]
                              ),
                              _c("input-by-type", {
                                staticClass: "new-ux",
                                attrs: { type: "text", outlined: "" },
                                model: {
                                  value: _vm.form.campoApoio,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "campoApoio", $$v)
                                  },
                                  expression: "form.campoApoio"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "carteira-administrada__required-hint text-xs text-color-900"
                        },
                        [_c("span", [_vm._v("* Campos obrigatórios")])]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("div", {
        staticStyle: {
          "border-top": "1px solid #8e8e8e80",
          "margin-block": "16px"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }